import FilterTags from '@creditflowresearch/uilib/FilterTags';

interface IProps {
  filters: Record<string, unknown>,
  filterFormatterData?: unknown,
  filtersFormatter: (key: string, filter: unknown, data: unknown) => string,
  allowedToRemoveFilters: string[],
  removableFilters?: string[],
  onTagRemove: (key: string, filter: unknown) => void,
}

const Tags = ({
  filters,
  allowedToRemoveFilters = [],
  removableFilters = allowedToRemoveFilters,
  filtersFormatter,
  filterFormatterData,
  onTagRemove,
}: IProps) => {
  const tags = Object.keys(filters).map((key) => ({
    key,
    label: filtersFormatter ? filtersFormatter(key, filters[key], filterFormatterData) : key,
    removable: removableFilters.includes(key) && allowedToRemoveFilters.includes(key),
  }));

  return <FilterTags tags={ tags } onTagRemove={ (key) => onTagRemove(key, filters[key]) } />;
};

export default Tags;
